import type { I18n } from 'vue-i18n';

export default class ValidationService {
  private i18n: I18n;

  constructor(i18n: I18n) {
    this.i18n = i18n;
  }

  defaultErrorMessages(input) {
    const errors = [];
    if (!input.$dirty) {
      return errors;
    }

    const t = (this.i18n.global as any).t;

    if (Object.hasOwn(input, 'required') && !input.required) {
      errors.push(t('global.form.validator.required'));
      return errors;
    }
    if (Object.hasOwn(input, 'minLength') && !input.minLength) {
      errors.push(t('global.form.validator.minLength', { length: input.$params.minLength.min }));
      return errors;
    }
    if (Object.hasOwn(input, 'maxLength') && !input.maxLength) {
      errors.push(t('global.form.validator.maxLength', { length: input.$params.maxLength.max }));
      return errors;
    }
    if (Object.hasOwn(input, 'email') && !input.email) {
      errors.push(t('global.form.validator.email'));
      return errors;
    }
    if (input.$error) {
      return ['Validation error'];
    }
    return errors;
  }

}
